var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 183,
    viewBox: "0 0 183 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_473_2396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 183,
    height: 183
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 183,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_473_2396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2319 167.75C80.684 167.75 70.7715 165.748 61.4944 161.745C52.2174 157.742 44.1476 152.309 37.2851 145.447C30.4226 138.584 24.9897 130.515 20.9866 121.238C16.9835 111.96 14.9819 102.048 14.9819 91.5C14.9819 80.9521 16.9835 71.0396 20.9866 61.7625C24.9897 52.4854 30.4226 44.4156 37.2851 37.5531C44.1476 30.6906 52.2174 25.2578 61.4944 21.2547C70.7715 17.2516 80.684 15.25 91.2319 15.25C101.78 15.25 111.692 17.2516 120.969 21.2547C130.247 25.2578 138.316 30.6906 145.179 37.5531C152.041 44.4156 157.474 52.4854 161.477 61.7625C165.48 71.0396 167.482 80.9521 167.482 91.5C167.482 102.048 165.48 111.96 161.477 121.238C157.474 130.515 152.041 138.584 145.179 145.447C138.316 152.309 130.247 157.742 120.969 161.745C111.692 165.748 101.78 167.75 91.2319 167.75ZM83.6069 152.119V137.25C79.4132 137.25 75.8231 135.757 72.8366 132.77C69.8502 129.784 68.3569 126.194 68.3569 122V114.375L31.7569 77.775C31.3757 80.0625 31.0262 82.35 30.7085 84.6375C30.3908 86.925 30.2319 89.2125 30.2319 91.5C30.2319 106.877 35.2835 120.348 45.3866 131.912C55.4897 143.477 68.2299 150.213 83.6069 152.119ZM136.219 132.675C138.761 129.879 141.049 126.861 143.082 123.62C145.115 120.38 146.799 117.012 148.133 113.517C149.468 110.022 150.485 106.432 151.184 102.747C151.882 99.0615 152.232 95.3125 152.232 91.5C152.232 79.0458 148.769 67.6719 141.843 57.3781C134.917 47.0844 125.672 39.65 114.107 35.075V38.125C114.107 42.3188 112.614 45.9089 109.627 48.8953C106.641 51.8818 103.051 53.375 98.8569 53.375H83.6069V68.625C83.6069 70.7854 82.8762 72.5964 81.4147 74.0578C79.9533 75.5193 78.1423 76.25 75.9819 76.25H60.7319V91.5H106.482C108.642 91.5 110.453 92.2307 111.915 93.6922C113.376 95.1536 114.107 96.9646 114.107 99.125V122H121.732C125.036 122 128.023 122.985 130.691 124.955C133.36 126.924 135.203 129.498 136.219 132.675Z",
    fill: "#1EB65B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.8f10a1e5d923badfd422def641c52fea.svg";
export { ForwardRef as ReactComponent };